import { Spinner } from '@material-tailwind/react'

export const Loading = () => {
  return (
    <div className="fixed w-full h-full top-0 left-0 z-50 flex items-center bg-background/70 justify-center">
      <Spinner className="w-12 h-12 text-secondary-bright" />
    </div>
  )
}
